import styled from 'styled-components';

export const Content = styled.div`
  padding: 0;
  box-sizing: border-box;
  background-color: #161e23;
  color: #e6eaec;
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 100%;
  border-radius: 14px;
  border: solid 1px #2c353d;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.62), 0 2px 0 rgba(255, 255, 255, 0.03) inset;
  z-index: 100000;
  max-width: 1000px;
  overflow: hidden;

  &.withLoading {
    &::after {
      content: '';
      z-index: 3;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      border-radius: 14px;
      background: rgba(16, 21, 26, 0.72) url('/images/loader.svg') no-repeat 50%;
      background-size: 60px auto;
    }
  }
`;

export const Inner = styled.div`
  padding: 22px 24px 24px 24px;
`;

/* Header — warning-accented bar. Time on the left, rack as a strong chip,
   the event message as the statement. Reads: "who / what happened". */
export const Title = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  min-height: 58px;
  padding: 10px 108px;
  background-color: #12171c;
  color: #e6eaec;
  border-radius: 14px 14px 0 0;
  border-bottom: 1px solid #e0932f;
  box-shadow: inset 0 2px 0 rgba(224, 147, 47, 0.14);
  letter-spacing: 0.2px;
  line-height: 1.35;
  flex-shrink: 0;

  .time {
    font-size: 13px;
    font-weight: 500;
    color: #7a838a;
    white-space: nowrap;
  }
  .rack {
    display: inline-flex;
    align-items: center;
    height: 26px;
    padding: 0 11px;
    border-radius: 999px;
    background: rgba(224, 147, 47, 0.14);
    border: 1px solid rgba(224, 147, 47, 0.5);
    color: #f0b666;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
  }
  .msg {
    font-size: 16px;
    font-weight: 500;
    color: #e6eaec;
  }
`;

export const Calls = styled.div`
  position: absolute;
  right: -58px;
  top: -17px;
  z-index: 2;
`;

/* Section eyebrow label above the comparison / decision zones. */
export const SectionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 2px 12px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: #7a838a;

  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #2c353d;
  }
`;

/* Decision bar — the primary action. Separated by a solid divider so it reads
   as the moment of decision, not just two more buttons. */
export const Buttons = styled.div`
  display: flex;
  justify-content: center;
  gap: 18px;
  margin-top: 22px;
  padding-top: 22px;
  border-top: 1px solid #2c353d;

  button {
    flex: 1;
    max-width: 260px;
    gap: 10px;
    svg {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
    }
  }
`;

/* Reference plate from the payment system (source of truth), shown as a quiet
   labelled strip beneath the comparison. */
export const PlateInfo = styled.div`
  display: flex;
  justify-content: center;
  margin: 16px auto 2px;
  max-width: 520px;
  padding: 12px 16px;
  background: #12171c;
  border: 1px solid #2c353d;
  border-radius: 12px;
`;

export const ItemContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const VehicleClassInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  max-width: 520px;
  margin: 16px auto 2px;
  padding: 14px 16px;
  background: #12171c;
  border: 1px solid #2c353d;
  border-radius: 12px;
`;

export const VehicleClass = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
